// 1. Import `extendTheme`
import { extendTheme } from "@chakra-ui/react";
// 2. Call `extendTheme` and pass your custom values
export default extendTheme({
  styles: {
    global: (props) => ({
      // Remove Chakra's default border focus outline and use :focus-visible instead
      ".js-focus-visible :focus:not([data-focus-visible-added])": {
        outline: "none",
        boxShadow: "none",
      },
      "html, body": {
        scrollBehavior: "smooth",
        color: props.colorMode === "dark" ? "white" : "gray.600",
        backgroundColor: "gray.100",
      },
      a: {
        color: props.colorMode === "dark" ? "teal.300" : "teal.500",
      },
      img: {
        userSelect: "none !important",
      },
    }),
  },
  colors: {
    brand: {
      100: "#3d53db",
      200: "#364bd2",
      300: "#3d53db",
      400: "#3d53db",
      500: "#3d53db",
      600: "#3d53db",
      700: "#3d53db",
      800: "#3d53db",
      900: "#364bd2",
    },
  },
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },
});
